import { createServerFn } from "@tanstack/react-start"
import { z } from "zod"

// Today's policy and the Compilations the Policy Tuner replays. The page then
// replays them a few at a time, so the first Companies show within a second.
export const loadPolicyTuner = createServerFn({ method: "GET" }).handler(
  async () => {
    const [
      { assertAdminContext },
      { listTunerCompilations },
      { PRODUCTION_ASSESSMENTS_READ_ON },
    ] = await Promise.all([
      import("@/lib/supabase/auth"),
      import("@/admin/policy-tuner/tuner-cases"),
      import("@/admin/monitoring/production-assessments"),
    ])

    // A server function is directly callable, so the route guard is not enough.
    await assertAdminContext()

    return {
      ...(await listTunerCompilations()),
      generatedAt: new Date().toISOString(),
      productionReadOn: PRODUCTION_ASSESSMENTS_READ_ON,
    }
  }
)

// One Policy Tuner case, rebuilt from the console's database, and the
// production posture its legacy Company shows today.
export const loadPolicyTunerCase = createServerFn({ method: "GET" })
  .inputValidator(z.object({ compilationId: z.string().uuid() }))
  .handler(async ({ data }) => {
    const [
      { assertAdminContext },
      { loadTunerCase },
      { productionAssessmentByLegacyCompanyId },
    ] = await Promise.all([
      import("@/lib/supabase/auth"),
      import("@/admin/policy-tuner/tuner-cases"),
      import("@/admin/monitoring/production-assessments"),
    ])
    await assertAdminContext()

    const replay = await loadTunerCase(data.compilationId)
    const { legacyCompanyId } = replay.tunerCase
    return {
      ...replay,
      tunerCase: {
        ...replay.tunerCase,
        productionPosture:
          (legacyCompanyId &&
            productionAssessmentByLegacyCompanyId[legacyCompanyId]?.posture) ||
          null,
      },
    }
  })

export type PolicyTunerData = Awaited<ReturnType<typeof loadPolicyTuner>>
export type PolicyTunerCase = Awaited<
  ReturnType<typeof loadPolicyTunerCase>
>["tunerCase"]
